export default __webpack_public_path__ + "static/media/key-rotated.6f0b4fbb.svg";